<template>
    <div class="member-tree">
     <!--   <el-tree
                v-if="assignType==='department'||assignType==='staff'"
                :data="memberListShow"
                node-key="id"
                :default-expand-all="defaultExpandAll"
                :default-expanded-keys="treeExpandData"
                :props="leadsAssignProps">
                          <span
                                  class="custom-tree-node"
                                  slot-scope="{ node, data }"
                          >
                               <div style="display: flex;justify-content: flex-start;align-items: center">
                                     <span v-if="!data.isMember">
                                       <i class="arsenal_icon arsenalsitemap1"
                                          style="font-size: 14px;padding-right: 4px;display: flex;align-items: center"></i>
                                      </span>
                                     <span v-if="data.isMember">
                                        <i class="arsenal_icon arsenaluser1"
                                           style="font-size: 14px;padding-right: 4px;display: flex;align-items: center"></i>
                                      </span>
                                      <span>{{ node.label }}</span>
                                 </div>
                            <span>
                                <el-radio-group
                                        v-model="member"
                                        @change="changeCheckedOrg(node,data)"
                                >
                                    <el-radio :label="data.id">
                                      {{labelNull}}
                                    </el-radio>
                                </el-radio-group>

                            </span>
                          </span>
        </el-tree>-->
        <el-input
                size="small"
                placeholder="请输入内容"
                suffix-icon="el-icon-search"
                v-model="filterText"
                style="margin-bottom: 12px"
        >
        </el-input>
        <el-tree
                :data="memberListShow"
                node-key="id"
                :default-expand-all="defaultExpandAll"
                :default-expanded-keys="treeExpandData"
                :props="leadsAssignProps"
                :filter-node-method="filterNode"
                ref="tree"
        >
                           <span
                                   class="custom-tree-node"
                                   slot-scope="{
                                                            node,
                                                            data,
                                                        }"
                           >
                                                        <div style="display: flex;justify-content: flex-start;align-items: center">
                                                             <span v-if="!data.isMember">
                                                               <i class="arsenal_icon arsenalsitemap1"
                                                                  style="font-size: 14px;padding-right: 4px;display: flex;align-items: center"></i>
                                                              </span>
                                                             <span v-if="data.isMember">
                                                                <i class="arsenal_icon arsenaluser1"
                                                                   style="font-size: 14px;padding-right: 4px;display: flex;align-items: center"></i>
                                                              </span>
                                                              <span>{{ node.label }}</span>
                                                         </div>
                                                        <span v-if="assignType==='checkMemberTree'">
                                                            <el-checkbox
                                                                    @change="changeCheckedOrg(node,data)"
                                                                    v-model="data.checked"
                                                                    :disabled="data.disabled"
                                                            ></el-checkbox>
                                                        </span>
                                                       <span v-if="assignType==='staff'&&data.isMember">
                                                        <el-radio-group
                                                                v-model="member"
                                                        >
                                                            <el-radio :label="data.id">
                                                              {{labelNull}}
                                                            </el-radio>
                                                        </el-radio-group>

                                                    </span>
                                                    </span>
        </el-tree>
    </div>
</template>

<script>
    import {showParent} from "@/assets/js/getChildrenLeng";

    export default {
        name: "memberTree",
        data() {
            return {
                defaultExpandAll: true,
                treeExpandData: [],
                leadsAssignProps: {
                    children: "children",
                    label: "name"
                },
                selectMember: [],
                member: '',
                labelNull: '',
                memberIdList: [],
                filterText:''
            }
        },
        props: {
            memberListShow: {
                type: Array,
                default() {
                    return []
                }
            },
            assignType: {
                type: String,
                default() {
                    return '';
                }
            }
        },
        methods: {
            filterNode(value, data) {
                if (!value) return true;
                return data.name.indexOf(value) !== -1;
            },
            changeOrgChildrenProperties(list, fun) {
                if (list == null || list.length == 0 || fun == null) {
                    return;
                }
                list.forEach(item => {
                    fun(item);
                    this.changeOrgChildrenProperties(item.children, fun);
                });

            },
            changeCheckedOrg(node, data) {
                console.debug('select member changed', data);
                this.changeOrgChildrenProperties(data.children, (item) => item.checked = data.checked);
                if (data.checked) {
                    this.changeOrgChildrenProperties([data], (item) => this.memberIdList.unshift(item));
                } else {
                    this.changeOrgChildrenProperties([data], (item) => {
                        this.memberIdList.forEach((cell, cellIndex) => {
                            if (cell.id == item.id) {
                                this.memberIdList.splice(cellIndex, 1);
                            }
                        });
                    });

                }
                this.memberIdList = [...this.memberIdList];
                console.log("memberIdList", this.memberIdList);
              showParent(this.memberIdList,0)
            },
            // 获取树形结构默认展开节点
            getRoleTreeRootNode(provincialCenterId) {
                this.treeExpandData.push(provincialCenterId)
            },
        },
        mounted() {
        },
        watch: {
            filterText(val) {
                this.$refs.tree.filter(val);
            }
        },

    }
</script>

<style scoped lang="less">
    .member-tree {
        .custom-tree-node {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 14px;
            padding-right: 8px;
        }

    }
</style>